module.exports = __webpack_public_path__ + "static/media/with_pant_cuffs.1d4a3953.svg";